import React, { useRef } from "react";
import { Container, Typography, TextField, Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../helperFunctions/cookie";
import {
  addUserToFamily,
  createFamily,
  getFamilyId,
} from "../../api-interactions/family";
import { updateUser } from "../../api-interactions/authentication";

export const SignupJoinFamily = () => {
  const familyCodeRef = useRef();
  const newFamilyNameRef = useRef();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const jwt = getCookie();

  const submitHandler = async (e) => {
    e.preventDefault();

    const familyId = await getFamilyId(familyCodeRef.current.value);
    await addUserToFamily(jwt, user, familyId);
    await updateUser({ familyId: familyId });

    navigate("/dashboard");
  };

  const createFamilyHandler = async (e) => {
    e.preventDefault();
    const familyId = await createFamily(
      jwt,
      user,
      newFamilyNameRef.current.value
    );
    await updateUser({ familyId });
    navigate("/dashboard");
  };

  return (
    <Container id="signin-container" maxWidth="xs">
      <Typography id="signin-text" component="h1" variant="h5">
        Join or Create a family!
      </Typography>
      <form id="signin-form">
        <TextField
          inputRef={familyCodeRef}
          type="text"
          required
          variant="outlined"
          label="Family Code"
          className="signin-form-input"
        />
        <Button onClick={submitHandler} type="submit" id="signin-btn">
          Join Family
        </Button>
      </form>
      <Typography variant="h6" id="or-text">
        Or
      </Typography>
      <form id="signin-form">
        <TextField
          inputRef={newFamilyNameRef}
          type="text"
          required
          variant="standard"
          label="New Family Name"
          className="signin-form-input"
        />
        <Button onClick={createFamilyHandler} type="submit" id="signin-btn">
          Create New Family
        </Button>
      </form>
    </Container>
  );
};
